(function() {
  
  let fetchIndex = 0;
  let form = document.querySelector('.download-product .search-form-custom');
  let inputSearch = document.querySelector('.download-product .search-form-custom input');
  
  form?.addEventListener('submit', function(e) {

    e.preventDefault();
    
    fetchIndex++;
    let curFetchIndex = fetchIndex;
    let value = inputSearch.value;
    
    if(value) {

      let siteLocale = '';
      if(Shopify.locale == 'en') siteLocale = '/en-en';
      let url = siteLocale+'/search?type=product&options%5Bprefix%5D=last&q='+value;
      
      fetch(url).then(response => response.text()).then(function(html) {

        if(curFetchIndex != fetchIndex) return;
        
        let parser = new DOMParser();
        let productsList = parser.parseFromString(html, 'text/html');
        productsList = productsList.querySelector('.yv-products-list');

        let productsEl = document.querySelector('.download-product .products-list');
        productsEl.querySelector('.yv-products-list')?.remove();
        productsEl.append(productsList);
        
      });
    }

    return false;
    
  });
  
})();